<template>
  <div class="vendor_cash_expense-main glass-tab-page">
    <div class="vendor_cash_expense-header-bar">
      <BrucdcumHeader
        :breadcrumb="['Vendor', 'Cash Expense']"
        :back-fallback="vendorsDashboardPath"
      />
    </div>
    <form class="vendor_cash_expense-form" @submit.prevent>
      <div class="glass-tab-view glass-tab-view--flush vendor_cash_expense-glass-shell">
        <div class="glass-tab-view__content vendor_cash_expense-tab-content">
          <div class="glass-tab-panel glass-tab-panel--flex-column glass-tab-panel--stagger-rows vendor_cash_expense-section">
            <div class="vendor_cash_expense-invoice-meta-row">
              <div class="vendor_cash_expense-form-group vendor_cash_expense-form-group--label-input vendor_cash_expense-meta-field">
                <LabelInputField
                  input-id="cash-expense-no"
                  label="No"
                  v-model="number"
                  placeholder="No"
                  flex
                />
              </div>
              <div class="vendor_cash_expense-form-group vendor_cash_expense-form-group--label-date vendor_cash_expense-meta-field">
                <LabelDateField
                  input-id="cash-expense-date"
                  label="Date"
                  v-model="dateUI"
                  flex
                  @change="onDateChange"
                />
              </div>
            </div>

            <div class="vendor_cash_expense-form-row vendor_cash_expense-form-row--columns glass-tab-panel__row">
              <div class="vendor_cash_expense-form-group vendor_cash_expense-form-group--label-dropdown vendor_cash_expense-required">
                <LabelDropdown
                  label="Pay From"
                  select-id="cash-expense-pay-from"
                  v-model="payFrom"
                  flex
                  wide
                  required
                  searchable
                  :options="payFromDropdownOptions"
                  :has-error="!!validationErrors.payFrom"
                  @change="onPayFromChange"
                >
                  <div v-if="validationErrors.payFrom" class="vendor_cash_expense-error-text">{{ validationErrors.payFrom }}</div>
                  <div v-if="payFromBalanceError" class="vendor_cash_expense-error-text">{{ payFromBalanceError }}</div>
                </LabelDropdown>
              </div>
              <div class="vendor_cash_expense-form-group vendor_cash_expense-form-group--label-dropdown">
                <LabelDropdown
                  label="Vendor Name"
                  select-id="cash-expense-vendor"
                  v-model="vendorId"
                  flex
                  wide
                  searchable
                  :options="vendorDropdownOptions"
                  @change="onVendorChange"
                />
              </div>
            </div>

            <div class="vendor_cash_expense-form-row vendor_cash_expense-form-row--columns glass-tab-panel__row">
              <div class="vendor_cash_expense-form-group vendor_cash_expense-form-group--label-dropdown">
                <LabelDropdown
                  label="Contact Name"
                  select-id="cash-expense-contact"
                  v-model="contactName"
                  flex
                  wide
                  searchable
                  :options="contactDropdownOptions"
                />
              </div>
              <div class="vendor_cash_expense-form-group vendor_cash_expense-form-group--label-input">
                <LabelInputField
                  input-id="cash-expense-phone"
                  label="Phone"
                  v-model="phone"
                  placeholder="Phone"
                  flex
                />
              </div>
            </div>

            <div class="vendor_cash_expense-itemize-wrap">
              <div class="vendor_cash_expense-itemize-tabs glass-tab-view__tabs">
                <TabNavigation
                  v-model="activeItemizeTab"
                  :tabs="itemizeTabs"
                />
              </div>

              <div
                v-show="activeItemizeTab === 'account'"
                role="tabpanel"
                class="vendor_cash_expense-itemize-section vendor_cash_expense-tab-panel glass-tab-panel--nested"
              >
                <div class="consultant-glass-table-section vendor_cash_expense-table-section">
                  <div class="consultant-glass-table-responsive consultant-glass-table-responsive--framed">
                    <div class="consultant-glass-table-scroll-x">
                      <table class="consultant-glass-table vendor_cash_expense-account-table vendor_cash_expense-itemize-table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Amount(USD)</th>
                            <th>Total</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, idx) in accountRows" :key="'account-' + idx" class="consultant-glass-table-row">
                            <td class="vendor_cash_expense-account-cell">
                              <LabelDropdown
                                :select-id="`cash-expense-account-${idx}`"
                                label="Account"
                                hide-label
                                v-model="row.accountId"
                                :options="accountDropdownOptions"
                                flex
                                searchable
                                custom-class="vendor_cash_expense-account-dropdown"
                                menu-class="vendor_cash_expense-account-dropdown-menu"
                                @change="handleAccountRowChange(row)"
                              />
                            </td>
                            <td><input v-model="row.description" type="text" /></td>
                            <td><input v-model="row.amount" type="number" min="0" step="any" /></td>
                            <td>{{ (Number(row.amount) || 0).toFixed(2) }}</td>
                            <td class="vendor_cash_expense-table-actions">
                              <SecondaryButton
                                label="Delete"
                                icon="bi bi-trash"
                                custom-class="consultant-secondary-btn--danger"
                                @click="removeAccountRow(idx)"
                              />
                            </td>
                          </tr>
                          <tr class="vendor_cash_expense-table-total-row">
                            <td colspan="5">
                              Total (USD): <span class="vendor_cash_expense-total-value">$ {{ (Number(accountTotal) || 0).toFixed(2) }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="vendor_cash_expense-itemize-add-wrap">
                  <PrimaryButton label="Add New Account" icon="bi bi-plus-lg" @click="addAccountRow" />
                </div>
              </div>

              <div
                v-show="activeItemizeTab === 'product'"
                role="tabpanel"
                class="vendor_cash_expense-itemize-section vendor_cash_expense-tab-panel glass-tab-panel--nested"
              >
                <div class="consultant-glass-table-section vendor_cash_expense-table-section">
                  <div class="consultant-glass-table-responsive consultant-glass-table-responsive--framed">
                    <div class="consultant-glass-table-scroll-x">
                      <table class="consultant-glass-table vendor_cash_expense-product-table vendor_cash_expense-itemize-table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Quantity</th>
                            <th>Unit Price</th>
                            <th>Total</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, idx) in productRows" :key="'product-' + idx" class="consultant-glass-table-row">
                            <td class="vendor_cash_expense-product-cell">
                              <LabelDropdown
                                :select-id="`cash-expense-product-${idx}`"
                                label="Product/Service"
                                hide-label
                                v-model="row.selectedItem"
                                :options="productServiceDropdownOptions(idx)"
                                flex
                                searchable
                                custom-class="vendor_cash_expense-product-dropdown"
                                menu-class="vendor_cash_expense-product-dropdown-menu"
                                @change="(value) => onProductServiceChange(row, value)"
                              />
                            </td>
                            <td><input v-model="row.description" type="text" /></td>
                            <td><input v-model="row.quantity" type="number" min="0" step="any" /></td>
                            <td><input v-model="row.unitPrice" type="number" min="0" step="any" /></td>
                            <td>
                              {{
                                (Number(row.quantity) || 0) * (Number(row.unitPrice) || 0)
                                  ? ((Number(row.quantity) || 0) * (Number(row.unitPrice) || 0)).toFixed(2)
                                  : ''
                              }}
                            </td>
                            <td class="vendor_cash_expense-table-actions">
                              <SecondaryButton
                                label="Delete"
                                icon="bi bi-trash"
                                custom-class="consultant-secondary-btn--danger"
                                @click="removeProductRow(idx)"
                              />
                            </td>
                          </tr>
                          <tr class="vendor_cash_expense-table-total-row">
                            <td colspan="6">
                              Total (USD): <span class="vendor_cash_expense-total-value">$ {{ (Number(productServiceTotal) || 0).toFixed(2) }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="vendor_cash_expense-itemize-add-wrap">
                  <PrimaryButton label="Add New Item" icon="bi bi-plus-lg" @click="addProductRow" />
                </div>
              </div>
            </div>

            <div class="vendor_cash_expense-form-group vendor_cash_expense-form-group--label-description">
              <LabelDescriptionField
                input-id="cash-expense-comments"
                label="Write comments for this Cash Expense."
                v-model="comments"
                placeholder="Comments"
                flex
              />
            </div>

            <div class="vendor_cash_expense-total-section glass-tab-panel--nested">
              <span>Total (USD)</span>
              <span class="vendor_cash_expense-total-value">$ {{ (Number(finalTotal) || 0).toFixed(2) }}</span>
            </div>

            <div class="vendor_cash_expense-secondary-actions">
              <SecondaryButton label="Make it recurring" icon="bi bi-arrow-repeat" @click="makeRecurring" />
              <SecondaryButton label="Save as draft" icon="bi bi-file-earmark" @click="saveAsDraft" />
            </div>
          </div>
        </div>
      </div>

      <div class="vendor_cash_expense-form-actions glass-tab-view__actions">
        <SecondaryButton label="Cancel" icon="bi bi-x-lg" @click="cancel" />
        <PrimaryButton label="Save and New" icon="bi bi-plus-lg" @click="saveAndNew" />
        <PrimaryButton label="Save and Close" icon="bi bi-check-lg" @click="saveAndClose" />
      </div>
    </form>

    <ErrorModal :show="showErrorModal" title="Error" :message="errorMessage" @close="closeErrorModal" />
    <VendorProductItemModal
      :show="showProductItemModal"
      :company-id="companyId"
      :preferred-vendor-id="vendorId"
      @close="closeProductItemModal"
      @saved="onProductItemCreated"
    />
    <VendorServiceItemModal
      :show="showServiceItemModal"
      :company-id="companyId"
      :preferred-vendor-id="vendorId"
      @close="closeServiceItemModal"
      @saved="onServiceItemCreated"
    />
  </div>
</template>

<script>
import '../styles/VendorCashExpense.css';
import BrucdcumHeader from '@/components/BrucdcumHeader.vue';
import TabNavigation from '@/components/TabNavigation.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import VendorProductItemModal from '@/modules/vendor/components/VendorProductItemModal.vue';
import VendorServiceItemModal from '@/modules/vendor/components/VendorServiceItemModal.vue';
import ApiService from '@/services/api.service.js';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import LabelDropdown from '@/modules/consultant/components/LabelDropdown.vue';
import LabelDescriptionField from '@/modules/consultant/components/LabelDescriptionField.vue';
import LabelDateField from '@/modules/consultant/components/LabelDateField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'VendorCashExpense',
  components: {
    BrucdcumHeader,
    TabNavigation,
    ErrorModal,
    VendorProductItemModal,
    VendorServiceItemModal,
    LabelInputField,
    LabelDropdown,
    LabelDescriptionField,
    LabelDateField,
    PrimaryButton,
    SecondaryButton,
  },
  data() {
    const today = new Date().toISOString().split('T')[0];
    return {
      validationErrors: {},
      showErrorModal: false,
      errorMessage: '',
      payFrom: '',
      payFromList: [],
      vendorId: '',
      contactName: '',
      phone: '',
      vendorList: [],
      contactList: [],
      date: today,
      number: '',
      comments: '',
      activeItemizeTab: 'product',
      itemizeTabs: [
        { id: 'product', name: 'Itemize by Product/Service' },
        { id: 'account', name: 'Itemize by Account' },
      ],
      accountRows: [{ accountId: '', description: '', amount: 0 }],
      productRows: [{ itemId: '', itemType: '', selectedItem: '', description: '', quantity: 0, unitPrice: 0 }],
      accountList: [],
      productList: [],
      serviceList: [],
      payFromBalanceError: '',
      showProductItemModal: false,
      showServiceItemModal: false,
      productItemModalRow: null,
      serviceItemModalRow: null,
    };
  },
  computed: {
    companyId() {
      return this.$route.params.id;
    },
    vendorsDashboardPath() {
      return `/company/${this.companyId}/dashboard/vendors`;
    },
    dateUI: {
      get() {
        return this.formatDateForUI(this.date);
      },
      set(val) {
        this.onDateChange(val);
      },
    },
    accountTotal() {
      return this.accountRows.reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
    },
    productServiceTotal() {
      return this.productRows.reduce(
        (sum, row) => sum + (Number(row.quantity) || 0) * (Number(row.unitPrice) || 0),
        0,
      );
    },
    productServiceList() {
      return [...(this.productList || []), ...(this.serviceList || [])];
    },
    finalTotal() {
      return (Number(this.accountTotal) || 0) + (Number(this.productServiceTotal) || 0);
    },
    vendorDropdownOptions() {
      return [
        { value: '', label: 'Select' },
        ...(this.vendorList || []).map((vendor) => ({
          value: String(vendor.id),
          label: vendor.vendorName,
        })),
        { value: '__new_vendor__', label: 'Create New Vendor' },
      ];
    },
    contactDropdownOptions() {
      return [
        { value: '', label: 'Select' },
        ...(this.contactList || []).map((contact) => ({
          value: contact.name,
          label: `${contact.name}${contact.email ? ` (${contact.email})` : ''}${contact.primary ? ' [Primary]' : ''}`,
        })),
      ];
    },
    payFromDropdownOptions() {
      return [
        { value: '', label: 'Select' },
        ...(this.payFromList || []).map((acc) => ({
          value: String(acc.id),
          label: `${acc.accountNumber ? acc.accountNumber + ' - ' : ''}${acc.accountName}${acc.accountType ? ' - ' + acc.accountType : ''}`,
        })),
        { value: '__new_account__', label: 'Create New Account' },
      ];
    },
    accountDropdownOptions() {
      return [
        { value: '', label: 'Select' },
        ...(this.accountList || []).map((account) => ({
          value: String(account.id),
          label: `${account.accountNumber ? account.accountNumber + ' - ' : ''}${account.accountName}${account.accountType ? ' - ' + account.accountType : ''}`,
        })),
        { value: '__new_account__', label: 'Add New Account' },
      ];
    },
  },
  watch: {
    vendorId(val) {
      const selected = this.vendorList.find((v) => String(v.id) === String(val));
      if (selected) {
        this.contactList = selected.contacts || [];
        this.contactName = '';
        this.phone = '';
      } else {
        this.contactList = [];
        this.contactName = '';
        this.phone = '';
      }
    },
    contactName(val) {
      const selectedContact = this.contactList.find((c) => c.name === val);
      if (selectedContact) {
        this.phone = selectedContact.phone || '';
      } else {
        this.phone = '';
      }
    },
    payFrom() {
      this.validatePayFromBalance();
    },
    accountRows: {
      handler() {
        this.validatePayFromBalance();
      },
      deep: true,
    },
    productRows: {
      handler() {
        this.validatePayFromBalance();
      },
      deep: true,
    },
  },
  async created() {
    try {
      const res = await ApiService.getCompanyAccounts(this.companyId);
      const allAccounts = res.data.accounts || res.data || [];
      this.payFromList = allAccounts.filter((a) =>
        ['Cash', 'Bank', 'Credit Card', 'Paypal'].includes(a.accountType),
      );
      this.accountList = allAccounts.filter((a) =>
        ['Expense', 'Other Expense', 'Cost of Goods Sold', 'Inventory Asset'].includes(a.accountType),
      );
    } catch (e) {
      this.payFromList = [];
      this.accountList = [];
    }
    try {
      await this.loadVendorList();
    } catch (err) {
      this.vendorList = [];
    }
    try {
      const productRes = await ApiService.get(`/vendor/product-items/company/${this.companyId}`);
      this.productList = (productRes.data || [])
        .filter((item) => item.billStatus === 'Available')
        .map((item) => ({
        id: item.id,
        name: item.productName,
        type: item.type || 'Product',
        salesPrice: item.salesPrice,
        purchasePrice: item.purchasePrice,
        preferredVendor: item.preferredVendor,
      }));
      const serviceRes = await ApiService.get(`/vendor/service-items/company/${this.companyId}`);
      this.serviceList = (serviceRes.data || [])
        .filter((item) => item.billStatus === 'Available')
        .map((item) => ({
        id: item.id,
        name: item.serviceName,
        type: item.type || 'Service',
        salesPrice: item.salesPrice,
        purchasePrice: item.purchasePrice,
        preferredVendor: item.preferredVendor,
      }));
    } catch (e) {
      this.productList = [];
      this.serviceList = [];
    }
  },
  methods: {
    formatDateForUI(isoDate) {
      if (!isoDate) return '';
      const parts = String(isoDate).split('-');
      if (parts.length !== 3) return isoDate;
      return `${parts[1]}/${parts[2]}/${parts[0]}`;
    },
    parseDateFromUI(value) {
      if (!value) return '';
      const parts = String(value).split('/');
      if (parts.length !== 3) return value;
      const [month, day, year] = parts;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    onDateChange(value) {
      this.date = this.parseDateFromUI(value);
    },
    clearFieldError(field) {
      if (this.validationErrors[field]) {
        const next = { ...this.validationErrors };
        delete next[field];
        this.validationErrors = next;
      }
    },
    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
    showValidationErrors(errors) {
      this.validationErrors = errors;
      const messages = Object.values(errors)
        .map((m) => `• ${m}`)
        .join('\n');
      this.errorMessage = `Please fix the following issues:\n\n${messages}`;
      this.showErrorModal = true;
    },
    validateForm() {
      const errors = {};
      if (!this.payFrom || this.payFrom === '__new_account__') {
        errors.payFrom = 'Pay From account is required.';
      }
      return errors;
    },
    validateAll() {
      const all = this.validateForm();
      this.validationErrors = all;
      if (Object.keys(all).length > 0) {
        this.showValidationErrors(all);
        return false;
      }
      return true;
    },
    cancel() {
      this.$router.push(this.vendorsDashboardPath);
    },
    onPayFromChange() {
      if (this.payFrom === '__new_account__') {
        this.payFrom = '';
        this.$router.push(`/company/${this.companyId}/dashboard/new-account`);
        return;
      }
      this.clearFieldError('payFrom');
      this.validatePayFromBalance();
    },
    onVendorChange() {
      if (this.vendorId === '__new_vendor__') {
        this.vendorId = '';
        this.$router.push(`/company/${this.companyId}/dashboard/vendors/new-vendor`);
      }
    },
    async saveAndClose() {
      if (!this.validateAll()) return;
      await this.validatePayFromBalance();
      if (this.payFromBalanceError) {
        if (this.$toast) this.$toast.error(this.payFromBalanceError);
        else {
          this.errorMessage = this.payFromBalanceError;
          this.showErrorModal = true;
        }
        return;
      }
      try {
        await this.saveCashExpense();
        if (this.$toast) this.$toast.success('Cash expense created successfully!');
        this.$router.push(this.vendorsDashboardPath);
      } catch (err) {
        const msg = err.response?.data?.error || err.message || 'Failed to save';
        if (this.$toast) this.$toast.error(msg);
        else {
          this.errorMessage = msg;
          this.showErrorModal = true;
        }
      }
    },
    async saveAndNew() {
      if (!this.validateAll()) return;
      await this.validatePayFromBalance();
      if (this.payFromBalanceError) {
        if (this.$toast) this.$toast.error(this.payFromBalanceError);
        else {
          this.errorMessage = this.payFromBalanceError;
          this.showErrorModal = true;
        }
        return;
      }
      try {
        await this.saveCashExpense();
        if (this.$toast) this.$toast.success('Cash expense created successfully!');
        this.resetForm();
      } catch (err) {
        const msg = err.response?.data?.error || err.message || 'Failed to save';
        if (this.$toast) this.$toast.error(msg);
        else {
          this.errorMessage = msg;
          this.showErrorModal = true;
        }
      }
    },
    addAccountRow() {
      this.accountRows.push({ accountId: '', description: '', amount: 0 });
    },
    removeAccountRow(idx) {
      this.accountRows.splice(idx, 1);
    },
    addProductRow() {
      this.productRows.push({ itemId: '', itemType: '', selectedItem: '', description: '', quantity: 0, unitPrice: 0 });
    },
    removeProductRow(idx) {
      this.productRows.splice(idx, 1);
    },
    handleAccountRowChange(row) {
      if (row.accountId === '__new_account__') {
        row.accountId = '';
        this.$router.push(`/company/${this.companyId}/dashboard/new-account`);
      }
    },
    async validatePayFromBalance() {
      this.payFromBalanceError = '';
      if (!this.payFrom || this.payFrom === '__new_account__') return;
      try {
        const res = await ApiService.get(`/company-account/${this.payFrom}`);
        const account = res.data.account || res.data;
        const total = this.finalTotal;
        if (account && Number(account.currentBalance) < total) {
          this.payFromBalanceError = 'Insufficient balance in the selected account.';
        }
      } catch (e) {
        this.payFromBalanceError = 'Unable to check account balance.';
      }
    },
    availableProductServiceItems(currentIdx) {
      const selectedIds = this.productRows
        .filter((row, idx) => idx !== currentIdx)
        .map((row) => `${row.itemId}-${row.itemType}`);
      return this.productServiceList.filter((item) => !selectedIds.includes(`${item.id}-${item.type}`));
    },
    productServiceDropdownOptions(rowIdx) {
      return [
        { value: '', label: 'Select' },
        ...this.availableProductServiceItems(rowIdx).map((item) => ({
          value: JSON.stringify({ id: item.id, type: item.type }),
          label: `${item.name} - ${item.type}`,
        })),
        { value: '__new_product__', label: 'Create New Product Item' },
        { value: '__new_service__', label: 'Create New Service Item' },
      ];
    },
    async loadVendorList() {
      const data = await ApiService.getAllVendors(this.companyId);
      this.vendorList = Array.isArray(data) ? data : (data?.data || []);
    },
    findVendorById(vendorId) {
      return (this.vendorList || []).find((vendor) => String(vendor.id) === String(vendorId));
    },
    findProductServiceItem(itemId, itemType) {
      if (itemId === '' || itemId == null) return null;
      const list = this.productServiceList || [];
      const byIdAndType = list.find(
        (item) => String(item.id) === String(itemId) && String(item.type) === String(itemType),
      );
      if (byIdAndType) return byIdAndType;
      return list.find((item) => String(item.id) === String(itemId)) || null;
    },
    resolveProductServiceUnitPrice(item) {
      if (!item) return 0;
      const purchasePrice = Number(item.purchasePrice);
      const salesPrice = Number(item.salesPrice);
      if (purchasePrice > 0) return purchasePrice;
      if (salesPrice > 0) return salesPrice;
      return 0;
    },
    async applyPreferredVendorFromItem(item) {
      if (!item?.preferredVendor) return;
      const preferredVendorId = String(item.preferredVendor);
      if (preferredVendorId === String(this.vendorId || '')) return;

      let preferredVendor = this.findVendorById(preferredVendorId);
      if (!preferredVendor) {
        await this.loadVendorList();
        preferredVendor = this.findVendorById(preferredVendorId);
      }
      if (preferredVendor) {
        this.vendorId = preferredVendorId;
      }
    },
    async onProductServiceChange(row, selectedValue) {
      const value = selectedValue !== undefined ? selectedValue : row.selectedItem;
      if (value === '__new_product__') {
        row.selectedItem = '';
        this.productItemModalRow = row;
        this.showProductItemModal = true;
        return;
      }
      if (value === '__new_service__') {
        row.selectedItem = '';
        this.serviceItemModalRow = row;
        this.showServiceItemModal = true;
        return;
      }
      if (typeof value === 'string' && value) {
        try {
          const parsed = JSON.parse(value);
          row.itemId = parsed.id;
          row.itemType = parsed.type;
          row.selectedItem = value;
        } catch (e) {
          row.itemId = '';
          row.itemType = '';
          row.selectedItem = '';
        }
      } else if (!value) {
        row.itemId = '';
        row.itemType = '';
        row.selectedItem = '';
      }
      const item = this.findProductServiceItem(row.itemId, row.itemType);
      row.unitPrice = this.resolveProductServiceUnitPrice(item);
      await this.applyPreferredVendorFromItem(item);
    },
    async applyCreatedItemToRow(row, item) {
      if (!row || !item) return;
      row.itemId = item.id;
      row.itemType = item.type;
      row.selectedItem = JSON.stringify({ id: item.id, type: item.type });
      row.unitPrice = this.resolveProductServiceUnitPrice(item);
      await this.applyPreferredVendorFromItem(item);
      if (!row.description && item.name) {
        row.description = item.name;
      }
    },
    onProductItemCreated(item) {
      this.productList.push(item);
      this.applyCreatedItemToRow(this.productItemModalRow, item);
      this.productItemModalRow = null;
      this.showProductItemModal = false;
    },
    onServiceItemCreated(item) {
      this.serviceList.push(item);
      this.applyCreatedItemToRow(this.serviceItemModalRow, item);
      this.serviceItemModalRow = null;
      this.showServiceItemModal = false;
    },
    closeProductItemModal() {
      this.showProductItemModal = false;
      this.productItemModalRow = null;
    },
    closeServiceItemModal() {
      this.showServiceItemModal = false;
      this.serviceItemModalRow = null;
    },
    async saveCashExpense() {
      const payload = {
        companyId: this.companyId,
        vendorId: this.vendorId,
        contactName: this.contactName,
        phone: this.phone,
        payFrom: this.payFrom,
        date: this.date,
        number: this.number,
        comments: this.comments,
        accountRecords: this.accountRows
          .filter((row) => row.accountId && row.accountId !== '__new_account__' && row.amount)
          .map((row) => ({
            accountId: row.accountId,
            description: row.description,
            amount: row.amount,
          })),
        itemRecords: this.productRows
          .filter((row) => row.itemId && row.itemType)
          .map((row) => ({
            itemId: row.itemId,
            itemType: row.itemType,
            description: row.description,
            quantity: row.quantity,
            unitPrice: row.unitPrice,
          })),
      };
      await ApiService.post('/vendor/cash-expense', payload);
    },
    resetForm() {
      this.validationErrors = {};
      this.activeItemizeTab = 'product';
      this.vendorId = '';
      this.contactName = '';
      this.phone = '';
      this.payFrom = '';
      this.payFromBalanceError = '';
      this.date = new Date().toISOString().split('T')[0];
      this.number = '';
      this.comments = '';
      this.accountRows = [{ accountId: '', description: '', amount: 0 }];
      this.productRows = [{ itemId: '', itemType: '', selectedItem: '', description: '', quantity: 0, unitPrice: 0 }];
      this.contactList = [];
    },
    makeRecurring() {
      if (this.$toast) this.$toast.info('Recurring expense is not implemented yet.');
    },
    saveAsDraft() {
      if (this.$toast) this.$toast.info('Save as draft is not implemented yet.');
    },
  },
};
</script>
